/* ============================================================================
   Oferti4ka — СЛОЙ МИКРО-ВЗАИМОДЕЙСТВИЯ
   Vanilla JS, Web Animations API, без библиотеки. Зарежда се с defer.

   Закача се ПРОГРЕСИВНО върху вече съществуващите класове:
   .card / .card-media / .card-cta / .card-wish / .btn / .hrail / .iconbtn
   .btn-atc / .ql / .tile / .sw / .sticky
   Картите се рендират от JS след fetch → всичко минава през делегиране
   на събития + MutationObserver. Ако елемент липсва, кодът мълчи.
   ========================================================================== */
(function(){
'use strict';

/* ------------------------------------------------------------------ помощни */
var $  = function(s,r){ return (r||document).querySelector(s); };
var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
var EO = 'cubic-bezier(.22,1,.36,1)';          /* --ease-out   */
var ES = 'cubic-bezier(.34,1.56,.64,1)';       /* --ease-spring */
var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
var RM = mq.matches;
if(mq.addEventListener) mq.addEventListener('change',function(e){ RM=e.matches; });

function esc(s){ return String(s).replace(/[&<>"']/g,function(c){
  return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
function num(t){ var v=parseFloat(String(t).replace(/[^\d,.\-]/g,'').replace(/\.(?=\d{3})/g,'').replace(',','.')); return isNaN(v)?0:v; }
function eur(v){ return v.toFixed(2).replace('.',',')+' €'; }
function fxMoney(v){ var a=v.toFixed(2).split('.'); return a[0]+'<i>,'+a[1]+' €</i>'; }
function anim(el,frames,opt){ if(RM||!el||!el.animate) return null; try{ return el.animate(frames,opt); }catch(e){ return null; } }
/* иконите: shell.js ги дава ту като обект ICON, ту като Proxy към icons.js.
   ICON е `const` на глобално ниво → не виси на window, затова минаваме
   през typeof, а ако липсва — мълчим с празен низ. */
function ico(k){
  try{ if(typeof ICON!=='undefined'&&ICON&&ICON[k]) return ICON[k]; }catch(e){}
  try{ if(window.icon&&window.IC) return window.icon(k)||''; }catch(e){}
  return '';
}

/* достъпно съобщение при действие */
var live;
function say(msg){
  if(!live){ live=document.createElement('div'); live.className='fx-live';
    live.setAttribute('role','status'); live.setAttribute('aria-live','polite');
    document.body.appendChild(live); }
  live.textContent='';
  setTimeout(function(){ live.textContent=msg; },30);
}

/* ============================================================================
   1. БУТОН „ДОБАВИ В КОЛИЧКАТА" — машина на състоянията
   ========================================================================== */
var ATC_SEL   = '.card-cta,.btn-atc,.sticky button,[data-fx-atc]';
var LOAD_MS   = 620;
var DONE_MS   = 1600;
var CHECK     = '<span class="fx-check" aria-hidden="true"><i></i><i></i></span>';

function isVariantBtn(b){ return /избери вариант|виж вариант/i.test(b.textContent||''); }

/* Формата зад бутона — само ако той наистина може да добави в количката.
   Върне ли null, няма какво да се подаде и кликът е чисто визуален. */
function atcForm(b){
  if(b.tagName==='A') return null;
  if(b.disabled||b.getAttribute('aria-disabled')==='true') return null;
  var f=b.form||b.closest('form');
  if(!f||(f.getAttribute('action')||'').indexOf('/cart/add')===-1) return null;
  var id=f.querySelector('[name="id"]');
  if(!id||!id.value||id.disabled) return null;
  return f;
}

function enhanceBtn(b){
  if(b.dataset.fxBtn) return;
  b.dataset.fxBtn='1';
  var label=(b.textContent||'').trim();
  b.dataset.fxLabel=label;
  b.classList.add('fx-btn');
  if(isVariantBtn(b)){                       /* карта с варианти → бърз преглед */
    b.dataset.fxVariant='1';
    b.innerHTML='<span class="fx-lyr fx-idle">'+esc(label)+'</span>';
    b.dataset.fxState='idle';
    return;
  }
  /* Ширината на бутона = най-широкият слой. При къс етикет („Добави" в
     мобилната лента) думите „Добавям…/Добавено" биха го раздули с ~60 px и
     биха изяли реда с името на продукта → там оставяме само знака. */
  var compact = label.length<=10;
  b.innerHTML =
    '<span class="fx-lyr fx-idle">'+esc(label)+'</span>'+
    '<span class="fx-lyr fx-load" aria-hidden="true"><span class="fx-spin"></span>'+
      (compact?'':'Добавям…')+'</span>'+
    '<span class="fx-lyr fx-done" aria-hidden="true">'+CHECK+(compact?'':'Добавено')+'</span>';
  b.dataset.fxState='idle';
}

function setState(b,st){
  b.dataset.fxState=st;
  b.setAttribute('aria-busy', st==='loading' ? 'true':'false');
  var map={idle:'fx-idle',loading:'fx-load',done:'fx-done'};
  ['fx-idle','fx-load','fx-done'].forEach(function(c){
    var el=b.querySelector('.'+c);
    if(el) el.setAttribute('aria-hidden', c===map[st] ? 'false':'true');
  });
}

/* колко броя добавяме — чете се от избраната стъпка, ако има такава */
function qtyFor(btn){
  var scope=btn.closest('.fxq-box')||btn.closest('.pdp-buy')||document;
  var on=scope.querySelector('.fxq-tile.on')||document.querySelector('.qty-ladder .ql.on');
  if(btn.closest('.fxq-box')) on=btn.closest('.fxq-box').querySelector('.fxq-tile.on');
  else if(btn.closest('.pdp-buy')||btn.closest('.sticky')) on=document.querySelector('.qty-ladder .ql.on');
  else return 1;
  if(!on) return 1;
  var m=(on.textContent||'').match(/\d+/);
  return m?Math.max(1,parseInt(m[0],10)):1;
}

/* коя снимка лети */
function sourceImg(btn){
  var card=btn.closest('.nx-card');
  if(card) return card.querySelector('.card-media img');
  var q=btn.closest('.fxq-box');
  if(q) return q.querySelector('.fxq-main img');
  return $('#hero')||$('.gal-main img')||$('.pdp-gal img');
}

function runAtc(btn){
  if(btn.dataset.fxState!=='idle') return;
  var qty=qtyFor(btn), img=sourceImg(btn);
  setState(btn,'loading');
  setTimeout(function(){
    setState(btn,'done');
    fly(img);
    /* само пулс: числото го рисува Shopify, като пререндира cart-icon-bubble */
    setTimeout(function(){ bumpCart(0); }, RM?0:430);
    say('Добавено в количката'+(qty>1?', '+qty+' броя':''));
    var box=btn.closest('.fxq-box');
    if(box) setTimeout(closeQuick, 1150);      /* бързият преглед се затваря сам */
  }, LOAD_MS);
  setTimeout(function(){ setState(btn,'idle'); }, LOAD_MS+DONE_MS);
}

/* ============================================================================
   2. ПОЛЕТ КЪМ КОЛИЧКАТА
   ========================================================================== */
function cartBtn(){
  var acts=$('.hdr-acts');
  if(!acts) return null;
  var all=$$('.iconbtn',acts);
  return all.length?all[all.length-1]:null;
}

function fly(img){
  var cart=cartBtn();
  if(RM||!img||!cart||!img.animate) return;
  var a=img.getBoundingClientRect(), b=cart.getBoundingClientRect();
  if(!a.width||!b.width) return;

  var g=document.createElement('img');
  g.className='fx-fly'; g.alt=''; g.src=img.currentSrc||img.src;
  g.style.left=a.left+'px'; g.style.top=a.top+'px';
  g.style.width=a.width+'px'; g.style.height=a.height+'px';
  document.body.appendChild(g);

  /* квадратична крива на Безие: изхвърча нагоре, после пада в иконата */
  var dx=(b.left+b.width/2)-(a.left+a.width/2);
  var dy=(b.top +b.height/2)-(a.top +a.height/2);
  var cx=dx*0.22, cy=Math.min(0,dy)-Math.max(140,Math.abs(dy)*0.42);
  var N=28, frames=[];
  for(var i=0;i<=N;i++){
    var t=i/N, u=1-t;
    var x=2*u*t*cx+t*t*dx, y=2*u*t*cy+t*t*dy;
    var s=1-0.84*t;
    frames.push({ transform:'translate('+x.toFixed(2)+'px,'+y.toFixed(2)+'px) scale('+s.toFixed(3)+')',
                  opacity: t<0.72?1:Math.max(0,1-(t-0.72)/0.28), offset:t });
  }
  var an=g.animate(frames,{duration:700,easing:'cubic-bezier(.45,0,.35,1)',fill:'forwards'});
  var kill=function(){ if(g.parentNode) g.parentNode.removeChild(g); };
  if(an.finished) an.finished.then(kill,kill); else an.onfinish=kill;
  setTimeout(kill,1400);
}

function bumpCart(q){
  var cart=cartBtn(); if(!cart) return;
  anim(cart,[{transform:'scale(1)'},{transform:'scale(1.24)',offset:.35},
             {transform:'scale(.94)',offset:.68},{transform:'scale(1)'}],
       {duration:520,easing:ES});
  /* Броят в баджа идва от Shopify — секцията cart-icon-bubble се пререндира
     след всяко добавяне. Смятахме ли го и тук, клиентът виждаше двойно.
     q>0 остава само за ръчна проверка през window.FX.bumpCart. */
  if(!q) return;
  var badge=cart.querySelector('.n'); if(!badge) return;
  var cur=badge.querySelector('.fx-num');
  if(!cur){
    var t=(badge.textContent||'0').trim();
    badge.textContent='';
    cur=document.createElement('span'); cur.className='fx-num'; cur.textContent=t;
    badge.appendChild(cur);
  }
  var next=(parseInt(cur.textContent,10)||0)+q;
  if(RM){ cur.textContent=String(next); return; }
  var ghost=document.createElement('span');
  ghost.className='fx-num-ghost'; ghost.textContent=cur.textContent; ghost.setAttribute('aria-hidden','true');
  badge.appendChild(ghost);
  cur.textContent=String(next);
  var out=anim(ghost,[{transform:'none',opacity:1},{transform:'translateY(-115%)',opacity:0}],
               {duration:320,easing:EO,fill:'forwards'});
  var kill=function(){ if(ghost.parentNode) ghost.parentNode.removeChild(ghost); };
  if(out&&out.finished) out.finished.then(kill,kill);
  setTimeout(kill,900);   /* мрежа: в скрит таб таймлайнът спира и finished не идва */
  anim(cur,[{transform:'translateY(115%)',opacity:0},{transform:'none',opacity:1}],{duration:320,easing:EO});
}

/* ============================================================================
   3. РОЛКА НА ЦЕНАТА + пружинно потвърждение на избора
   ========================================================================== */
/* какво се превърта: само числата, които носят решение. Ако сложим и
   .ql-per / .ql-save, при смяна на размер тръгват 16 ролки наведнъж и
   екранът започва да трепти — затова редовете движат само общата сума. */
var ROLL_SEL=['#price','#stprice','#old','#pct','#btot','.ql-tot','.fxq-now .money'];

function snapRolls(){
  var snap=[];
  ROLL_SEL.forEach(function(sel){
    $$(sel).forEach(function(el,i){ snap.push([sel,i,el.innerHTML,(el.textContent||'').trim()]); });
  });
  return snap;
}
function playRolls(snap){
  if(RM||!snap) return;
  var by={};
  snap.forEach(function(r){ (by[r[0]]=by[r[0]]||[])[r[1]]=[r[2],r[3]]; });
  Object.keys(by).forEach(function(sel){
    $$(sel).forEach(function(el,i){
      var prev=by[sel][i];
      if(!prev) return;
      if(prev[1]===(el.textContent||'').trim()) return;
      roll(el,prev[0]);
    });
  });
}
function roll(el,oldHTML){
  if(RM||!el.animate) return;
  el.classList.add('fx-roll');
  var g=document.createElement('span');
  g.className='fx-roll-ghost'; g.innerHTML=oldHTML; g.setAttribute('aria-hidden','true');
  el.appendChild(g);
  var out=anim(g,[{transform:'none',opacity:1},{transform:'translateY(-.5em)',opacity:0}],
               {duration:260,easing:EO,fill:'forwards'});
  var kill=function(){
    if(g.parentNode) g.parentNode.removeChild(g);
    if(!el.querySelector('.fx-roll-ghost')) el.classList.remove('fx-roll');
  };
  if(out&&out.finished) out.finished.then(kill,kill);
  setTimeout(kill,900);
  anim(el,[{transform:'translateY(.45em)',opacity:0},{transform:'none',opacity:1}],
       {duration:320,easing:EO});
}
function spring(el){
  anim(el,[{transform:'scale(1)'},{transform:'scale(.958)',offset:.3},
           {transform:'scale(1.015)',offset:.62},{transform:'scale(1)'}],
       {duration:400,easing:EO});
}

/* хващаме избора В ФАЗА НА ПРИХВАЩАНЕ — преди страницата да пренапише DOM-а */
document.addEventListener('click',function(e){
  var t=e.target;
  if(!t||!t.closest) return;
  var pick=t.closest('.ql,.tile,.sw,.fxq-tile,.gal-thumbs button');
  if(!pick||pick.disabled) return;
  var host=pick.parentElement;
  var kind=pick.classList.contains('ql')?'.ql.on':
           pick.classList.contains('tile')?'.tile.on':
           pick.classList.contains('sw')?'.sw.on':
           pick.classList.contains('fxq-tile')?'.fxq-tile.on':null;
  var snap=snapRolls();
  /* setTimeout, не rAF: страницата пренаписва DOM-а синхронно в своя handler,
     а rAF е замразен във фонов таб — ролката не бива да зависи от компози́тора */
  setTimeout(function(){
    playRolls(snap);
    if(!kind||!host) return;
    var on=host.querySelector(kind);
    spring(on&&on.isConnected?on:(pick.isConnected?pick:null));
  },0);
},true);

document.addEventListener('change',function(e){
  if(!e.target.closest||!e.target.closest('.bundle')) return;
  var snap=snapRolls();
  setTimeout(function(){ playRolls(snap); },0);
},true);

/* ============================================================================
   4. ПРОДУКТОВА КАРТА
   ========================================================================== */
function enhanceCard(card){
  if(card.dataset.fxCard||card.classList.contains('fx-skel')) return;
  card.dataset.fxCard='1';
  var media=card.querySelector('.card-media');
  if(!media) return;

  /* втора снимка — рендерът може да я подаде като data-img2 на <img> */
  var img=media.querySelector('img');
  if(img&&img.dataset.img2&&!media.querySelector('.fx-img2')){
    var i2=document.createElement('img');
    i2.className='fx-img2'; i2.src=img.dataset.img2; i2.alt=''; i2.loading='lazy'; i2.setAttribute('aria-hidden','true');
    media.appendChild(i2);
  }

  /* бърз преглед + сравни */
  if(!media.querySelector('.fx-acts')){
    var acts=document.createElement('div');
    acts.className='fx-acts';
    acts.innerHTML='<button type="button" class="fx-act" data-fx="quick">Бърз преглед</button>'+
                   '<button type="button" class="fx-act" data-fx="cmp" aria-pressed="false">Сравни</button>';
    media.appendChild(acts);
  }
}

/* натискане вместо hover на тъч */
document.addEventListener('pointerdown',function(e){
  if(e.pointerType==='mouse'||!e.target.closest) return;
  var card=e.target.closest('.nx-card');
  if(card) card.classList.add('fx-press');
},{passive:true});
['pointerup','pointercancel','pointerleave'].forEach(function(ev){
  document.addEventListener(ev,function(){
    $$('.card.fx-press').forEach(function(c){ c.classList.remove('fx-press'); });
  },{passive:true});
});

/* ============================================================================
   5. ЕДИН ДЕЛЕГИРАН КЛИК ЗА ВСИЧКО
   ========================================================================== */
document.addEventListener('click',function(e){
  var t=e.target;
  if(!t||!t.closest) return;

  var wish=t.closest('.card-wish');
  if(wish){
    e.preventDefault();
    var on=wish.classList.toggle('fx-on');
    wish.setAttribute('aria-pressed',on?'true':'false');
    wish.classList.remove('fx-pop'); void wish.offsetWidth;
    if(!RM&&on) wish.classList.add('fx-pop');
    say(on?'Добавено в любими':'Премахнато от любими');
    return;
  }

  var act=t.closest('.fx-act');
  if(act){
    e.preventDefault();
    if(act.dataset.fx==='quick'){ openQuick(act.closest('.nx-card'),act); return; }
    var p=act.getAttribute('aria-pressed')==='true';
    act.setAttribute('aria-pressed',p?'false':'true');
    act.textContent=p?'Сравни':'За сравнение';
    spring(act);
    say(p?'Махнато от сравнението':'Добавено за сравнение');
    return;
  }

  var btn=t.closest(ATC_SEL);
  if(btn){
    if(btn.closest('.fxq-x')) return;
    enhanceBtn(btn);
    if(btn.dataset.fxVariant==='1'){ e.preventDefault(); openQuick(btn.closest('.nx-card'),btn); return; }
    /* Тук се РИСУВА, не се добавя. Подаването на формата продължава по
       своя път: на PDP го поема Dawn (product-form.js), за картите в
       решетката — nexum-drawer.js. Спираме събитието единствено когато
       зад бутона няма форма, иначе бихме глътнали добавянето. */
    if(!atcForm(btn)) e.preventDefault();
    runAtc(btn);
    return;
  }

  if(t.closest('[data-fxq-close]')) closeQuick();
});

/* депресия при клавиатура (Enter/Space) — :active не се задейства навсякъде */
document.addEventListener('keydown',function(e){
  if(e.key!=='Enter'&&e.key!==' ') return;
  var el=document.activeElement;
  if(el&&el.classList&&el.classList.contains('fx-btn')) el.classList.add('fx-press');
});
document.addEventListener('keyup',function(){
  $$('.fx-btn.fx-press').forEach(function(b){ b.classList.remove('fx-press'); });
});

/* ============================================================================
   6. ХОРИЗОНТАЛНИ ЛЕНТИ — маски, стрелки, инерция
   ========================================================================== */
function enhanceRail(rail){
  if(rail.dataset.fxRail) return;
  rail.dataset.fxRail='1';
  var wrap=rail.closest('.hrail-wrap')||rail.parentElement;
  if(wrap) wrap.classList.add('fx-rail-wrap');

  function sync(){
    if(!wrap) return;
    var max=rail.scrollWidth-rail.clientWidth;
    wrap.classList.toggle('fx-l', rail.scrollLeft>6);
    wrap.classList.toggle('fx-r', max>8 && rail.scrollLeft<max-6);
  }
  rail.addEventListener('scroll',sync,{passive:true});
  window.addEventListener('resize',sync);
  if(window.ResizeObserver){ try{ new ResizeObserver(sync).observe(rail); }catch(e){} }
  if(window.MutationObserver){ new MutationObserver(sync).observe(rail,{childList:true}); }
  sync();

  /* влачене с мишка + инерция */
  var down=false,drag=false,sx=0,sl=0,moved=0,v=0,lx=0,lt=0,raf=0;
  function stopGlide(){ if(raf) cancelAnimationFrame(raf); raf=0; }
  function release(){
    rail.classList.remove('fx-drag');
    rail.style.scrollBehavior='';
    rail.style.scrollSnapType='';
  }
  rail.addEventListener('pointerdown',function(e){
    if(e.pointerType!=='mouse'||e.button!==0) return;
    if(e.target.closest('button,input,select,textarea')) return;
    stopGlide();
    down=true; drag=false; moved=0; v=0;
    sx=e.clientX; sl=rail.scrollLeft; lx=e.clientX; lt=performance.now();
  });
  rail.addEventListener('pointermove',function(e){
    if(!down) return;
    var dx=e.clientX-sx;
    if(!drag){
      if(Math.abs(dx)<5) return;
      drag=true;
      rail.classList.add('fx-drag');
      rail.style.scrollBehavior='auto';
      rail.style.scrollSnapType='none';
      try{ rail.setPointerCapture(e.pointerId); }catch(err){}
    }
    moved=Math.abs(dx);
    rail.scrollLeft=sl-dx;
    var now=performance.now(), dt=now-lt;
    if(dt>0){ v=(e.clientX-lx)/dt*15; lx=e.clientX; lt=now; }
  });
  rail.addEventListener('dragstart',function(e){ if(drag) e.preventDefault(); });
  function end(){
    if(!down) return;
    down=false;
    if(!drag){ return; }
    drag=false;
    if(moved>6){
      var swallow=function(ev){ ev.stopPropagation(); ev.preventDefault(); };
      rail.addEventListener('click',swallow,true);
      setTimeout(function(){ rail.removeEventListener('click',swallow,true); },60);
    }
    if(RM||Math.abs(v)<1.2){ release(); return; }
    var vv=v;
    (function step(){
      vv*=0.93;
      rail.scrollLeft-=vv;
      if(Math.abs(vv)>0.4) raf=requestAnimationFrame(step);
      else { raf=0; release(); }
    })();
  }
  rail.addEventListener('pointerup',end);
  rail.addEventListener('pointercancel',end);
  rail.addEventListener('pointerleave',function(){ if(down&&!drag) down=false; });
}

/* ============================================================================
   7. СКЕЛЕТИ ПРИ ЗАРЕЖДАНЕ
   ========================================================================== */
var SKEL='<div class="fx-sk fx-sk-media"></div><div class="fx-sk fx-sk-l w40"></div>'+
         '<div class="fx-sk fx-sk-l w90"></div><div class="fx-sk fx-sk-l w65"></div>'+
         '<div class="fx-sk fx-sk-price"></div><div class="fx-sk fx-sk-cta"></div>';
function skeletons(){
  $$('.grid,.hrail').forEach(function(c){
    if(c.children.length) return;
    var n=c.classList.contains('grid')?8:6, h='', i;
    for(i=0;i<n;i++) h+='<article class="card fx-skel" aria-hidden="true">'+SKEL+'</article>';
    c.innerHTML=h;
    setTimeout(function(){ if(c.querySelector('.fx-skel')) c.innerHTML=''; },12000);
  });
}

/* ============================================================================
   8. РАЗКРИВАНЕ ПРИ СКРОЛ — веднъж, само надолу, на групи по 60 ms
   ========================================================================== */
var RV_SEL='.sec,.edit,.col-seo,.sec-rail,.hero,.carriers,.ftr-top,.col-head,.tabs,'+
           '.assure .wrap>div,.cattiles>*,.brands>*,.rev-head,.faq,.spec-t';
var rvIO=null;
function revealInit(){
  if(RM||!('IntersectionObserver' in window)) return;
  rvIO=new IntersectionObserver(function(entries){
    var hit=entries.filter(function(en){ return en.isIntersecting; })
                   .sort(function(a,b){ return a.boundingClientRect.top-b.boundingClientRect.top; });
    hit.forEach(function(en,i){
      var el=en.target, d=Math.min(i,4)*60;
      el.style.transitionDelay=d+'ms';
      el.classList.add('fx-in');
      setTimeout(function(){ el.style.transitionDelay=''; }, d+700);
      rvIO.unobserve(el);
    });
  },{rootMargin:'0px 0px -6% 0px',threshold:0.04});
}
/* Аварийна мрежа. Разкриването скрива съдържание, преди да го покаже —
   ако IntersectionObserver по някаква причина не се обади (throttled таб,
   спрян рендерер, изключение), секция може да остане невидима завинаги.
   Затова метем и на ръка: всичко, което е влязло навътре в екрана, се
   показва независимо от наблюдателя. Прагът е същият като при първото
   обхождане, така че нищо, което е влязло в екрана, не остава празно
   по-дълго от един такт. IO се обажда за ~16 ms и на практика винаги
   изпреварва метлата, затова стъпалото от 60 ms се пази. */
function revealSweep(){
  if(RM||!rvIO) return;
  $$('.fx-rv:not(.fx-in)').forEach(function(el){
    var r=el.getBoundingClientRect();
    if(r.top<innerHeight*0.92&&r.bottom>0){ el.classList.add('fx-in'); rvIO.unobserve(el); }
  });
}
var sweepT=0;
window.addEventListener('scroll',function(){
  var now=Date.now();
  if(now-sweepT<400) return;
  sweepT=now; revealSweep();
},{passive:true});
document.addEventListener('visibilitychange',revealSweep);
setTimeout(revealSweep,2000);
setTimeout(revealSweep,5000);

function revealScan(){
  if(RM||!rvIO) return;
  $$(RV_SEL).forEach(function(el){
    if(el.dataset.fxRv) return;
    if(el.closest('.pdp-buy,.sticky,.fxq,.panel,#hdr,.hdr')) return;
    if(el.classList.contains('fx-skel')) return;
    el.dataset.fxRv='1';
    var r=el.getBoundingClientRect();
    if(r.top < innerHeight*0.92) return;      /* вече е на екрана → без мигане */
    el.classList.add('fx-rv');
    rvIO.observe(el);
  });
}

/* ============================================================================
   9. БЪРЗ ПРЕГЛЕД
   ========================================================================== */
var qBox=null, qPrev=null, QT=[{q:1,d:0},{q:2,d:.06},{q:3,d:.10}];

function readCard(card){
  var img   = card.querySelector('.card-media img');
  var title = card.querySelector('.card-title');
  var price = card.querySelector('.card-now .money');
  var vtxt  = '';
  $$('.card-price div',card).forEach(function(d){ if(/вариант/i.test(d.textContent)) vtxt=d.textContent.trim(); });
  var imgs=[];
  if(img) imgs.push(img.currentSrc||img.src);
  if(img&&img.dataset.img2) imgs.push(img.dataset.img2);
  return {
    imgs:imgs,
    title: title?title.textContent.trim():'Продукт',
    href:  title?(title.getAttribute('href')||'product.html'):'product.html',
    price: price?num(price.textContent):0,
    oldHTML: card.querySelector('.card-oldrow')?card.querySelector('.card-oldrow').innerHTML:'',
    rateHTML:card.querySelector('.card-rate')?card.querySelector('.card-rate').innerHTML:'',
    stock: card.querySelector('.card-stock')?card.querySelector('.card-stock').textContent.trim():'',
    flags: card.querySelector('.card-flags')?card.querySelector('.card-flags').innerHTML:'',
    sku:   card.querySelector('.card-sku')?card.querySelector('.card-sku').textContent.trim():'',
    vars:  vtxt
  };
}

function quickHTML(d){
  var thumbs = d.imgs.length>1 ? '<div class="fxq-thumbs">'+d.imgs.map(function(u,i){
      return '<button type="button" class="'+(i?'':'on')+'" data-i="'+i+'" aria-label="Снимка '+(i+1)+'">'+
             '<img src="'+esc(u)+'" alt=""></button>'; }).join('')+'</div>' : '';
  var tiles = QT.map(function(t,i){
      var per=d.price*(1-t.d), tot=per*t.q;
      return '<button type="button" class="fxq-tile'+(i?'':' on')+'" data-i="'+i+'" data-q="'+t.q+'">'+
             '<b>'+t.q+' '+(t.q===1?'брой':'броя')+'</b>'+
             '<span class="fxq-per">'+eur(per)+' за брой</span>'+
             (t.d?'<em>спестяваш '+eur((d.price-per)*t.q)+'</em>':'<span>общо '+eur(tot)+'</span>')+
             '</button>'; }).join('');
  return ''+
  '<div class="fxq-ov" data-fxq-close></div>'+
  '<div class="fxq-box" role="dialog" aria-modal="true" aria-labelledby="fxq-t">'+
    '<button type="button" class="fxq-x" data-fxq-close aria-label="Затвори бързия преглед">'+(ico('close')||'✕')+'</button>'+
    '<div class="fxq-grid">'+
      '<div class="fxq-gal">'+
        '<div class="fxq-main"><div class="fxq-flag card-flags">'+d.flags+'</div>'+
          '<img src="'+esc(d.imgs[0]||'')+'" alt="'+esc(d.title)+'"></div>'+
        thumbs+
      '</div>'+
      '<div class="fxq-info">'+
        (d.sku?'<div class="fxq-sku">'+esc(d.sku)+'</div>':'')+
        '<h2 class="fxq-t" id="fxq-t">'+esc(d.title)+'</h2>'+
        (d.rateHTML?'<div class="fxq-rate">'+d.rateHTML+'</div>':'')+
        '<div class="fxq-old">'+d.oldHTML+'</div>'+
        '<div class="fxq-now"><span class="money">'+fxMoney(d.price)+'</span></div>'+
        (d.vars?'<div class="fxq-lbl">Варианти</div><div style="font-size:12.5px;color:var(--ink-2)">'+
                esc(d.vars)+'. Избираш ги на пълната страница.</div>':'')+
        '<div class="fxq-lbl">Избери брой</div>'+
        '<div class="fxq-tiles">'+tiles+'</div>'+
        (d.stock?'<div class="fxq-stock"><span class="dot"></span> '+esc(d.stock)+'</div>':'')+
        /* Тук НЯМА „Добави в количката“: попоувърът се строи от DOM-а на
           картата, без избран вариант, а плочките отгоре показват отстъпки
           за 2 и 3 броя, каквито Shopify не прилага. Бутон, който добавя на
           различна цена от показаната, е по-лош от липсващ — истинският
           път е пълната страница. */
        '<a class="fxq-full" href="'+esc(d.href)+'">Виж пълната страница →</a>'+
        '<div class="fxq-cod">'+
          '<span>'+ico('cash')+'Плащане при получаване</span>'+
          '<span>'+ico('back')+'Връщане до 30 дни, без причина</span>'+
        '</div>'+
      '</div>'+
    '</div>'+
  '</div>';
}

function openQuick(card,from){
  if(!card) return;
  var d=readCard(card);
  if(!qBox){
    qBox=document.createElement('div');
    qBox.className='fxq'; qBox.id='fxq';
    document.body.appendChild(qBox);
  }
  qPrev=from||document.activeElement;
  qBox.innerHTML=quickHTML(d);
  qBox.hidden=false;
  document.documentElement.classList.add('fx-lock');
  void qBox.offsetWidth;
  qBox.classList.add('fx-on');

  var box=qBox.querySelector('.fxq-box');
  /* галерия */
  $$('.fxq-thumbs button',qBox).forEach(function(b){
    b.addEventListener('click',function(){
      $$('.fxq-thumbs button',qBox).forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on');
      var im=qBox.querySelector('.fxq-main img');
      im.src=d.imgs[+b.dataset.i];
      anim(im,[{opacity:0},{opacity:1}],{duration:200,easing:EO});
    });
  });
  /* количествени плочки — цената се превърта през общата ролка */
  $$('.fxq-tile',qBox).forEach(function(b){
    b.addEventListener('click',function(){
      $$('.fxq-tile',qBox).forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on');
      var t=QT[+b.dataset.i], per=d.price*(1-t.d);
      qBox.querySelector('.fxq-now .money').innerHTML=fxMoney(per);
    });
  });
  /* фокус капан */
  setTimeout(function(){ var f=focusables(box)[0]; (f||box).focus(); },40);
  box.addEventListener('keydown',function(e){
    if(e.key!=='Tab') return;
    var f=focusables(box); if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey&&document.activeElement===last){ e.preventDefault(); first.focus(); }
  });
}
function focusables(root){
  return $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])',root)
    .filter(function(el){ return el.offsetParent!==null; });
}
function closeQuick(){
  if(!qBox||qBox.hidden) return;
  qBox.classList.remove('fx-on');
  document.documentElement.classList.remove('fx-lock');
  var back=qPrev;
  setTimeout(function(){
    qBox.hidden=true; qBox.innerHTML='';
    if(back&&back.isConnected&&back.focus) back.focus();
  },RM?0:220);
}
document.addEventListener('keydown',function(e){
  if(e.key==='Escape'&&qBox&&!qBox.hidden){ e.stopPropagation(); closeQuick(); }
});

/* ============================================================================
   10. ОБХОЖДАНЕ + НАБЛЮДЕНИЕ (картите идват след fetch)
   ========================================================================== */
function scan(){
  $$(ATC_SEL).forEach(enhanceBtn);
  $$('.nx-card').forEach(enhanceCard);
  $$('.hrail').forEach(enhanceRail);
  $$('.card-wish').forEach(function(w){
    if(!w.hasAttribute('aria-pressed')) w.setAttribute('aria-pressed','false');
  });
  revealScan();
}

var pending=false;
function schedule(){
  if(pending) return;
  pending=true;
  setTimeout(function(){ pending=false; scan(); },0);
}

function boot(){
  skeletons();
  revealInit();
  scan();
  if(window.MutationObserver){
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  }
  window.addEventListener('load',schedule);
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
else boot();

/* малък отвор за проверка от конзолата */
window.FX={ scan:scan, skeletons:skeletons, fly:fly, bumpCart:bumpCart,
            openQuick:openQuick, closeQuick:closeQuick,
            reduced:function(){ return RM; } };
})();
